// Copyright (c) 2025. CYBERKOALA LLC.
//
// SPDX-License-Identifier: Proprietary License.
//
// Redistribution and use in source and binary forms, with or without
// modification, are restricted.

import React from 'react';
import { keyboardShortcutsContext } from './keyboard-shortcuts-context';

export const KeyboardShortcutsProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {

  return (
    <keyboardShortcutsContext.Provider value={{}}>
      {children}
    </keyboardShortcutsContext.Provider>
  );
};
